module.exports = __webpack_public_path__ + "static/media/mini-review-box-free.5f8bd6ee.png";